import Cookies from "js-cookie";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog/dialog";
import { useEmpBlockModal } from "./use-emp-block-modal";
import { editEmployee } from "@/config/mutation/admin";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { AxiosError } from "axios";
import { Button } from "@/components/ui/button/button";

export const EmpBlockModal = () => {
  const key = Cookies.get("key") as string;
  const queryClient = useQueryClient();

  const { open, onOpenChange, emp } = useEmpBlockModal();

  const { mutate, isPending: isEditing } = useMutation({
    mutationFn: editEmployee(key),
  });

  function onSubmit() {
    mutate(
      {
        empId: emp?.id as string,
        postData: {
          blocked: !emp?.prevBool,
        },
      },
      {
        onSuccess: async () => {
          // console.log("New Employee", data);
          await queryClient.invalidateQueries({
            queryKey: ["employees"],
          });
          await queryClient.invalidateQueries({
            queryKey: ["employee", emp!.id],
          });
          onOpenChange(false);
          toast.success(`Employee ${emp?.prevBool ? "unblocked" : "blocked"}`);
        },

        onError: (error) => {
          console.log("ERROR WHILE Saving employee details", error);
          const isAxiosError = error instanceof AxiosError;
          if (isAxiosError) {
            const errorReason = error?.response?.data?.error as string;
            toast.error(errorReason);
          } else {
            toast.error(error?.message);
          }
        },
      }
    );
  }

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="">
          <DialogHeader>
            <DialogTitle>Are you absolutely sure?</DialogTitle>
            <DialogDescription>
              {emp?.prevBool ? "Unblock" : "Block"} Employee
            </DialogDescription>
          </DialogHeader>

          <div className="mt-5 flex items-center justify-end">
            <Button onClick={onSubmit} disabled={isEditing}>
              {emp?.prevBool ? "Unblock" : "Block"}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
